;
(function () {
	if (!$("body").hasClass("home")) return;

	console.log("home.js");


	var timeBetweenSlides = 7000;
	var slideFadeTime = 600;
	var blockFadeTime = 300;

	var offsetBetweenTopAndBottom = 400;
	var offsetBetweenBlocks = 500;


	window.$slides = $(".main-slideshow .slide").get();

	if (window.$slides.length === 1) {
		timeBetweenSlides = 100000000;
		$('.slideshow-dots').hide();
		console.log("one slide!!")
	}
	var mode = $(".main-slideshow").data("mode");
	mode = "timed"; //console.warn("debugging modes", mode);

	if (mode == "normal") {
		// do nothing

	} else if (mode == "random-start") {
		var r = Math.ceil(Math.random() * $slides.length);
		for (var i = 0; i < r; i++) {
			$slides.push($slides.shift());
		};

	} else if (mode == "random") {
		shuffle($slides);

	} else if (mode == "timed") {
		var start = 1451606400; // jan 1, 2016
		var timeSince = Date.now() / 1000 - start;
		var daysSince = Math.floor(timeSince / 86400);
		var daysIntoCycle = daysSince % $slides.length;
		for (var i = 0; i < daysIntoCycle; i++) {
			$slides.push($slides.shift());
		};
	}

	$slides = $($slides);

	$slides.each(function (i, e) {
		//console.log($(e).data("id"))
		var $dot = $("<a href='javascript:;'></a>");
		$dot.appendTo(".slideshow-dots");
		if (i == 0) {
			$dot.addClass("active");
		}
		$dot.on("click", function () {
			slideSpecific(i);
			console.log("go to slide ", i)
		})
	})

	// pause any videos
	// $(".slide-video")


	window.slidePrev = function () {

		$(".main-slideshow .slide:visible").fadeOut(slideFadeTime);
		var $next = $(".main-slideshow .slide:visible").prev();
		if ($next.length == 0) {
			$next = $(".main-slideshow .slide").last();
		}

		$(".slideshow-dots a").removeClass("active").eq($next.index()).addClass("active")

		$next.fadeIn(slideFadeTime);
	}

	window.slideNext = function () {

		$(".main-slideshow .slide:visible").fadeOut(slideFadeTime);
		var $next = $(".main-slideshow .slide:visible").next();
		if ($next.length == 0) {
			$next = $(".main-slideshow .slide").first();
		}

		$(".slideshow-dots a").removeClass("active").eq($next.index()).addClass("active")

		$next.fadeIn(slideFadeTime);
	}

	window.slideSpecific = function (n) {

		//if ( $(".main-slideshow .slide:visible").data("player") ) {
		//	var player = $(".main-slideshow .slide:visible").data("player");
		//	if (player.getPlayerState() == 1) {
		//		player.pauseVideo();
		//	}
		//}

		slideshowActive = false;

		$(".main-slideshow .slide:visible").fadeOut(slideFadeTime);
		var $next = $(".main-slideshow .slide").eq(n);
		if ($next.length == 0) {
			$next = $(".main-slideshow .slide").first();
		}

		$(".slideshow-dots a").removeClass("active").eq($next.index()).addClass("active")

		$next.fadeIn(slideFadeTime);
	}

	$(".main-slideshow img").on("mousedown", function (e) {
		e.preventDefault()
	})

	var debouncedSlidePrev = debounce(slidePrev, 1000, true);
	var debouncedSlideNext = debounce(slideNext, 1000, true);

	// console.log("hammer added 2")
	var mc = new Hammer(document.querySelector(".main-slideshow"));
	mc.on('swipeleft', function () {
		// console.log("swipleft")
		slideshowActive = false;
		debouncedSlideNext();
	});
	mc.on('swiperight', function () {
		// console.log("swiperight")
		slideshowActive = false;
		debouncedSlidePrev();
	});



	// THE YOUTUBES
	/*
	// 2. This code loads the IFrame Player API code asynchronously.
	var tag = document.createElement('script');
	
	tag.src = "https://www.youtube.com/iframe_api";
	var firstScriptTag = document.getElementsByTagName('script')[0];
	firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);


	// 3. This function creates an <iframe> (and YouTube player)
	//    after the API code downloads.
	var players = {};
	window.onYouTubeIframeAPIReady = function() {

		console.log("onYouTubeIframeAPIReady");
		
		$(".make_video_here").each(function() {
			var id = $(this).data("youtube-id");
			var loop = $(this).data("loop");
			var autoplay = $(this).data("autoplay");
			var controls = $(this).data("controls");
			var mute = $(this).data("mute");

			console.log(id, loop, autoplay, controls, mute);
		
			var player = new YT.Player($(this).attr("id"), {
				videoId: id,
				playerVars: { 
					'autoplay': 		autoplay, 
					'loop': 			loop, 
					'controls': 		controls,
					'showinfo': 		0,
					'autohide': 		2,
					'modestbranding': 	1,
					'rel': 				0
				},
    			events: {
					'onReady': function(event) {
						onPlayerReady(event);
						if (mute) event.target.mute();
					},
					'onStateChange': onPlayerStateChange
				}
			});

			console.log($(".make_video_here").parents(".slide").data("player", player));

			players[$(this).attr("id")] = player;
		})

		// console.log(players);
	}

	// 4. The API will call this function when the video player is ready.
	function onPlayerReady(event) {
		//event.target.playVideo();
		setTimeout(function() {
			later = true;
		}, 1000)
	}

	// 5. The API calls this function when the player's state changes.
	//    The function indicates that when playing a video (state=1),
	//    the player should play for six seconds and then stop.
	var later = false;
	function onPlayerStateChange(event) {
		if (event.data == YT.PlayerState.PLAYING && later) {
			console.log("user played video, stop slideshow");
			stopSlideshow();
		} else if (event.data == YT.PlayerState.ENDED) {
			startSlideshow();
		}
	}
	function stopVideo() {
		player.stopVideo();
	}

	*/





	// BOTTOM BLOCKS

	var $blockCols = $(".blocks .col");

	var blockNext = function ($col) {

		$col = $($col); // not sure why we have to rewrap in jquery....

		var $blocks = $col.find(".block");
		var $currentBlock = $col.find(".block:visible");
		var $currentImage = $currentBlock.find("img:visible");
		var $images = $currentBlock.find("img");

		// console.log($col);

		if ($currentImage.next().length) {
			// console.log("more images in this block, show next");
			$currentImage.fadeOut(blockFadeTime);
			$currentImage.next().fadeIn(blockFadeTime);

		} else if ($currentBlock.next().length) {
			// console.log("out of images in this block, but there are more blocks, so go to next block");
			$currentBlock.fadeOut(blockFadeTime)
			$currentBlock.next().fadeIn(blockFadeTime);

			$currentBlock.next().find("img").hide().first().show(); // make sure first image is showing in next block

		} else if ($col.find(".block").length == 1 && $currentBlock.find("img").length == 1) {
			// console.log("only one block, only one image, so do nothing");

		} else if ($col.find(".block").length == 1 && $currentBlock.find("img").length > 1) {
			// console.log("only one block, but multiple images, so loop the images");
			$currentImage.fadeOut(blockFadeTime);
			$images.first().fadeIn(blockFadeTime);

		} else if ($col.find(".block").length > 1) {
			// console.log("more than one block, but out of images in this one, so loop the blocks");
			$currentBlock.fadeOut(blockFadeTime);
			$blocks.first().fadeIn(blockFadeTime);

			$blocks.first().find("img").hide().first().show(); // make sure first image is showing in next block

		} else {
			// console.warn("none of the above.");
		}

	}





	// console.log("home.js blocks 2")
	var slideshowInterval;
	var slideshowActive = true;
	var startSlideshow = function () {
		clearInterval(slideshowInterval);
		slideshowInterval = setInterval(function () {
			if (slideshowActive) slideNext();
			setTimeout(blockNext, offsetBetweenTopAndBottom + offsetBetweenBlocks * 0, [$blockCols[0]]);
			setTimeout(blockNext, offsetBetweenTopAndBottom + offsetBetweenBlocks * 1, [$blockCols[1]]);
			setTimeout(blockNext, offsetBetweenTopAndBottom + offsetBetweenBlocks * 2, [$blockCols[2]]);
			setTimeout(blockNext, offsetBetweenTopAndBottom + offsetBetweenBlocks * 3, [$blockCols[3]]);
			setTimeout(blockNext, offsetBetweenTopAndBottom + offsetBetweenBlocks * 4, [$blockCols[4]]);
		}, timeBetweenSlides)
	};
	window.stopBlocksSlideshow = function () {
		clearInterval(slideshowInterval);
	}

	startSlideshow();


})();